(function($) {
    $.widget("ca.caLoadingSplash", {
        options:{
            title: '',
            subtitle: ''
        },
        SpriteAnim: function(options) {
            var timerId, i = 0,
                element = document.getElementById(options.elementId);
            if (element != undefined && element) {
                element.style.width = options.width + "px";
                element.style.height = options.height + "px";
                element.style.backgroundRepeat = "no-repeat";
                element.style.backgroundImage = "url(" + options.sprite + ")";

                timerId = setInterval(function () {
                    if (i >= options.frames) {
                        i = 0;
                    }
                    element.style.backgroundPosition = "-" + i * options.width + "px 0px";
                    i++;
                }, 100);

                this.stopAnimation = function () {
                    clearInterval(timerId);
                };
            }
        },
        _create: function(){
            this.splashScreen = $('<div></div>').appendTo('body')
            this.splashScreen.dialog({
                title: this.options.title,
                subtitle: this.options.subtitle,
                modal : false,
                autoOpen : false,
                draggable : false,
                resizable : false,
                width : 110,
                height : 110,
                dialogClass: 'ca-loading-splash-container'
            });

            var uiDialog = this.splashScreen.parent();
            uiDialog.removeClass('ui-corner-all ui-widget-content');
            this.splashScreen.removeClass('ui-dialog-content ui-widget-content');
            uiDialog.children('.ui-dialog-titlebar').remove();
            $('<div id="overlay_layer" class="overlay_layer" style="display: block;"></div>').appendTo("body");
            $('<br/><div align="center" class="new_ajax_loader"><div id="loading_splash_div"></div></div>').appendTo(this.splashScreen);
            $('.overlay_layer').hide();

            var Loading = new this.SpriteAnim({
                width: 66,
                height: 66,
                frames: 8,
                sprite: "/public/images/ca/loading-splash/loading.png",
                elementId : "loading_splash_div"
            });
        },
        progressValue : function(value){
            this.progressBar.progressbar('value',value);
        },
        show : function(){
            this.splashScreen.dialog('open');
            $('.overlay_layer').show();
        },
        hide : function(){
            $(document).off('focusin.dialog');

            this.splashScreen.dialog('close');
            $('.overlay_layer').hide();
        }
    });
})(jQuery);